const MenuItems = [
  {
    text: "Regiones",
    icon: "fas fa-angle-right",
    path: `${process.env.PUBLIC_URL}/inicio-regiones`
  },
  {
    text: "Temáticas Ambientales",
    icon: "fas fa-angle-right",
    path: `${process.env.PUBLIC_URL}/inicio-tematicas`
  },
  {
    text: "Estadísticas",
    icon: "fas fa-angle-right",
    path: `${process.env.PUBLIC_URL}/estadisticas`
  },
  {
    text: "Mapas",
    icon: "fas fa-angle-right",
    path:`${process.env.PUBLIC_URL}/mapas`
  },
  {
    text: "Publicaciones",
    icon: "fas fa-angle-right",
    path: `${process.env.PUBLIC_URL}/publicaciones`
  },
  {
    text: "Normas",
    icon: "fas fa-angle-right",
    path: `${process.env.PUBLIC_URL}/normas`
  }
];
export default MenuItems;
